import {Badge} from '@chakra-ui/react';
import {StarIcon as ChakraStarIcon} from '@chakra-ui/icons';
import {useTotalPaniers} from 'ff-common';
import {useClient} from '@/haligator-factory';
import {getModeTheme} from '@/utils/appMode';

// Composant icône pour NavButton — les props height/color sont ignorés car le badge a son propre style
export const PaniersBadge: React.FC<{height?: string; color?: string}> = () => {
  const client = useClient();
  const totalPaniers = useTotalPaniers(client);
  const {modeColor} = getModeTheme();
  return (
    <Badge
      borderRadius='4px'
      bg={modeColor('blue.main', 'red.assistance')}
      color='white'
      fontSize='xs'
      fontWeight='700'
      minW='22px'
      h='22px'
      display='flex'
      alignItems='center'
      justifyContent='center'
    >
      {totalPaniers}
    </Badge>
  );
};

// Wrapper pour StarIcon de Chakra — convertit height en boxSize pour compatibilité NavButton
export const StarIcon: React.FC<{height?: string; color?: string}> = ({
  height,
  color,
}) => (
  <ChakraStarIcon
    boxSize={height}
    color={color}
  />
);
